export interface InitPackageIdentifier {
  name: string;
  version: string;
  /** Absolute path to the package */
  path: string;
}
